import { Messages } from '../../config';
import {
  ENDPOINT_CLIENT_COUPONS,
  ENDPOINT_CLIENT_GET_COUPONS
} from '../../config/endpoints';
import { getAxios } from '../axios';
import {
  getTokenHeaders,
  addParam,
  errorCatch, getNotificationId,
} from '../helper';
import { store } from "../../store/store";
import { displayNotification } from "../../store/actions/notification";
import { NOTIFICATION_SUCCESS } from "../../store/actions/types";

/**
 * Get list of coupons
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.campaign_id
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @returns {Promise<T>}
 */
export function getCouponsApi(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_COUPONS,
      {
        '{campaign}': payload.campaign_id,
        '{coupon}': '',
      }
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Create a coupon
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.name
 * @param {string} payload.data.campaign_id
 * @param {string} payload.data.notes
 * @param {string} payload.data.start_date
 * @param {string} payload.data.end_date
 * @param {object} payload.data.tracking
 * @param {object} payload.data.campaign_trackings.tracking_label
 * @param {object} payload.data.campaign_trackings.tracking_id
 * @returns {Promise<T>}
 */
export function createCoupon(payload) {
  return getAxios().post(
      addParam(
        ENDPOINT_CLIENT_COUPONS,
        {
          "{campaign}": payload.campaign_id,
          "{coupon}": "",
        }
      ),
      payload.data,
      getTokenHeaders()
    ).then(
      response => {
        if (response && response.status === 201) {
          store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null));
          return response.data;
        }

        return null;
      }
    ).catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );

        return e.response;
      }
    );
}

/**
 * Get campaign
 * @param {object} payload
 * @param {string} [payload.id]
 * @param {string} [payload.campaign_id]
 * @param {boolean} payload.hideNotification
 * @returns {Promise<T>}
 */
export function getCouponApi(payload) {
  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_GET_COUPONS,
      {
        '{coupon}': payload.id,
      }
    ),
    getTokenHeaders()
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Create a campaign
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.status
 * @returns {Promise<T>}
 */
export function updateCoupon(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_CLIENT_GET_COUPONS,
      {
        "{coupon}": payload.id,
      }
    ),
    payload.data,
    getTokenHeaders()
  ).then(
    response => {
      if (response && response.status === 200) {
        store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null));
        return response.data;
      }

      return null;
    }
  ).catch(
    e => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;


    }
  );
}
